import { cn } from '../../utils/cn';

/**
 * Loading placeholders that keep the page's shape.
 *
 * A full-page spinner blanks everything the user was oriented by; a skeleton
 * holds the layout so the eye stays where the data will appear. Pages here
 * previously used six different spinner treatments, several full-page.
 */
export function Skeleton({ className }) {
	return <div className={cn('animate-pulse rounded-md bg-accent/80', className)} />;
}

/** A stat-tile row placeholder matching MetricTiles' layout. */
export function TilesSkeleton({ count = 3 }) {
	return (
		<div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
			{Array.from({ length: count }).map((_, i) => (
				<div key={i} className="rounded-xl border border-border bg-card p-4 shadow-card">
					<Skeleton className="h-3 w-16" />
					<Skeleton className="mt-3 h-6 w-10" />
				</div>
			))}
		</div>
	);
}

/** A table/list placeholder: header bar plus n rows. */
export function TableSkeleton({ rows = 5 }) {
	return (
		<div className="rounded-lg border border-border bg-card overflow-hidden">
			<div className="border-b border-border bg-muted px-4 py-3">
				<Skeleton className="h-3 w-40" />
			</div>
			<div className="divide-y divide-border">
				{Array.from({ length: rows }).map((_, i) => (
					<div key={i} className="flex items-center gap-4 px-4 py-4">
						<Skeleton className="h-9 w-9 rounded-full shrink-0" />
						<div className="flex-1 space-y-2">
							<Skeleton className="h-3 w-1/3" />
							<Skeleton className="h-3 w-1/5" />
						</div>
						<Skeleton className="h-5 w-16 rounded-full" />
					</div>
				))}
			</div>
		</div>
	);
}

export default Skeleton;
